import axios from 'axios'

export default {
    // GETUNAUTHVIDEOS ({commit}, videoType) {
    GETUNAUTHVIDEOS ({commit}, csvTags) {
        // return axios.get(`/playlists/getJWPlaylistByTitle/${videoType}/0`).then((response) => { // commented on 07/29/2024 for TT-975
        return axios.get(`/playlists/listJWPVideosForGivenTags/${csvTags}`).then((response) => {
            const {data: {data}} = response
            commit('setAllUnauthVideos', {videos: data})
            // Get Work Video
            let workVideo = 'work'
            workVideo = data.filter(workVideo => {
                return workVideo.tags.indexOf('work-promo') > -1
            })
            commit('setWorkVideo', {videoObject: workVideo.slice(0, 24)})
            // Get Mindbody Video
            let mindbodyVideo = 'mindbody'
            mindbodyVideo = data.filter(mindbodyVideo => {
                return mindbodyVideo.tags.indexOf('mindbody-promo') > -1
            })
            commit('setMindbodyVideo', {videoObject: mindbodyVideo.slice(0, 24)})
            // Get Community Video
            let communityVideo = 'community'
            communityVideo = data.filter(communityVideo => {
                return communityVideo.tags === 'community'
            })
            commit('setCommunityVideo', {videoObject: communityVideo.slice(0, 3)})
            // Get Life Video
            let lifeVideo = 'life'
            lifeVideo = data.filter(lifeVideo => {
                return lifeVideo.tags.indexOf('life-promo') > -1
            })
            commit('setLifeVideo', {videoObject: lifeVideo.slice(0, 24)})
            // Get Money Video
            let moneyVideo = 'money'
            moneyVideo = data.filter(moneyVideo => {
                return moneyVideo.tags.indexOf('money-promo') > -1
            })
            commit('setMoneyVideo', {videoObject: moneyVideo.slice(0, 24)})
            // Get Main Video
            let mainVideo = 'main'
            mainVideo = data.filter(mainVideo => {
                return mainVideo.tags === 'main'
            })
            commit('setMainVideo', {videoObject: mainVideo[0]})
            // Get AboutUs Video
            let aboutusVideo = 'aboutus'
            aboutusVideo = data.filter(aboutvid => {
                return aboutvid.tags === 'aboutus'
            })
            commit('setAboutUsVideo', {videoObject: aboutusVideo[0]})
            // Get Live Event Video
            let liveEventVideo = data.filter(eventVideo => {
                return eventVideo.tags === 'live-event'
            })
            commit('setLiveEventVideo', {videoObject: liveEventVideo[0]})
            // Get Work Learn More Video
            let learnWork = 'learn-work'
            learnWork = data.filter(learnWork => {
                return learnWork.tags === 'learn-work'
            })
            commit('setWorkLearnMoreVideo', {videoObject: learnWork[0]})
            // Get Work Learn More Video
            let learnLife = 'learn-life'
            learnLife = data.filter(learnLife => {
                return learnLife.tags === 'learn-life'
            })
            commit('setLifeLearnMoreVideo', {videoObject: learnLife[0]})
            // Get Mindbody Learn More Video
            let learnMindbody = 'learn-mindbody'
            learnMindbody = data.filter(learnMindbody => {
                return learnMindbody.tags === 'learn-mindbody'
            })
            commit('setMindbodyLearnMoreVideo', {videoObject: learnMindbody[0]})
            // Get Money Learn More Video
            let learnMoney = 'learn-money'
            learnMoney = data.filter(learnMoney => {
                return learnMoney.tags === 'learn-money'
            })
            commit('setMoneyLearnMoreVideo', {videoObject: learnMoney[0]})
            // Get Community Learn More Video
            let learnCommunity = 'learn-community'
            learnCommunity = data.filter(learnCommunity => {
                return learnCommunity.tags === 'learn-community'
            })
            commit('setCommunityLearnMoreVideo', {videoObject: learnCommunity[0]})
        }, (err) => {
            console.log('err ', err)
        })
    },
    TRIGGERLOGINPOPUP ({commit}, loginStatus) {
        commit('setTriggerLogin', {loginStatus: loginStatus})
    },
    GETTESTIMONIALS ({commit}, page) {
        return axios.get(`/user/getTestimonialsData/${page}`).then((response) => {
            const {data: {data}} = response
            if (data && !data.error && data.completed) {
                commit('setAllTestimonials', {testimonials: data.payload})
            } else {
                commit('setAllTestimonials', {testimonials: null})
            }
        })
    },
    GETCOMPANYLOGOS ({commit}, page) {
        return axios.get(`/common/getAllHomePageLogo/${page}`).then((response) => {
            const {data: {data}} = response
            if (data && !data.error && data.completed) {
                commit('setCompanyLogos', {logos: data.payload})
            } else {
                commit('setCompanyLogos', {logos: null})
            }
        })
    },
    GET_CORP_BY_GIFTCODE ({commit}, giftCode) {
        return axios.get(`/corporations/findByGiftCode/${giftCode}`).then((response) => {
            const {data: {data}} = response
            if (data && !data.error && data.completed) {
                commit('setCorpReference', {corp: data.payload})
            } else {
                commit('setCorpReference', {corp: null})
            }
        })
    }
}




// WEBPACK FOOTER //
// ./src/store/unauthpage/actions.js